/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Callback_Back_To_HomeInputs */

const en_callback_back_to_home = /** @type {(inputs: Callback_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const fr_callback_back_to_home = /** @type {(inputs: Callback_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

const ms_sg2_callback_back_to_home = /** @type {(inputs: Callback_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke halaman utama`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Callback_Back_To_HomeInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const callback_back_to_home = /** @type {((inputs?: Callback_Back_To_HomeInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Callback_Back_To_HomeInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_callback_back_to_home(inputs)
	if (locale === "fr") return fr_callback_back_to_home(inputs)
	return ms_sg2_callback_back_to_home(inputs)
});